export default function createReducer(initialState, handlers) {
  return (state = initialState, action = {}) => {
    const handler = handlers[action.type] || (() => state);
    return handler(state, action.payload);
  };
}
